import {
    ADMINMAPPINGLANGUAGE_SUCCESS,
    ADMINMAPPINGLANGUAGE_FAILED,
    RESET_ADMINMAPPINGLANGUAGE,
    LOADING_ADMINMAPPINGLANGUAGE,
    NETWORK_ERROR_ADMINMAPPINGLANGUAGE
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMINMAPPINGLANGUAGE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMINMAPPINGLANGUAGE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMINMAPPINGLANGUAGE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMINMAPPINGLANGUAGE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMINMAPPINGLANGUAGE:
            return (state = initialState);
        default:
            return state;
    }
};